import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Draggable from 'gsap/Draggable';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(Draggable);

document.addEventListener('DOMContentLoaded', () => {

    // Existing animations for fade and parallax effects
    const fadeUpElements = document.querySelectorAll('.anmi-fadeup');
    fadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 100%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.02
        });
    });

    const boxfadeUpElements = document.querySelectorAll('.box-fadeup');
    boxfadeUpElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top-=100 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    const fadeLeftElements = document.querySelectorAll('.anmi-fadeleft');
    fadeLeftElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            x: -50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    const fadeBottomElements = document.querySelectorAll('.anmi-fadebottom');
    fadeBottomElements.forEach((element, index) => {
        gsap.from(element, {
            scrollTrigger: {
                trigger: element,
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            duration: 1,
            opacity: 0,
            y: 50,
            ease: 'power2.out',
            stagger: 0.15,
            delay: index * 0.15
        });
    });

    // Parallax animations
    gsap.fromTo('.para-100200', { y: -100 }, {
        y: 200,
        scrollTrigger: {
            trigger: '.parrablock',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        }
    });

    gsap.fromTo('.para100-100', { y: 100 }, {
        y: -100,
        scrollTrigger: {
            trigger: '.parrablock',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        }
    });

});



    // // Trigger horizontal scroll in 'boxessection' only when in view
    // const boxesSection = document.querySelector('.boxessection'); // Make sure the class name is correct

    // ScrollTrigger.create({
    //     trigger: boxesSection,
    //     start: 'top top',
    //     end: 'bottom bottom',
    //     onEnter: () => {
    //         // Enable horizontal scroll animation when entering the section
    //         TRIGGER.enable();
    //     },
    //     onLeave: () => {
    //         // Disable animation when leaving the section
    //         TRIGGER.disable();
    //     },
    //     onEnterBack: () => {
    //         // Re-enable animation when scrolling back into the section
    //         TRIGGER.enable();
    //     },
    //     onLeaveBack: () => {
    //         // Disable when scrolling back out from the top
    //         TRIGGER.disable();
    //     },
    // });


export default function initInitGsap() {
	gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(Draggable);

}
